import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { analyticsService } from '@/services/analytics.service';

export function useDashboardStats() {
  return useQuery({
    queryKey: ['analytics', 'dashboard'],
    queryFn: () => analyticsService.getDashboardStats(),
    staleTime: 1000 * 60 * 5,
    refetchInterval: 1000 * 60 * 5,
  });
}

export function useComprehensiveDashboard() {
  return useQuery({
    queryKey: ['analytics', 'comprehensive'],
    queryFn: () => analyticsService.getComprehensiveDashboard(),
    staleTime: 1000 * 60 * 3,
    refetchInterval: 1000 * 60 * 3,
  });
}

export function useDeleteDraftCourses() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => analyticsService.deleteDraftCourses(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['analytics'] });
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });
}
